import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  padding: 16px;
`;

export const TextTitle = styled.p`
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.2px;
`;

export const TextAnswerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TextAnswerTitle = styled.p`
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
  text-overflow: ellipsis;
`;

export const TextAnswer = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 24px;
`;

export const ShowAnswerButton = styled.p`
  color: ${({ theme }) => theme.colors.green7};
  cursor: pointer;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  border: none;
`;
